// removed by extract-text-webpack-plugin
module.exports = {"letterBar":"letterBar--ggrB1"};